
  // Redirect ?page=2 on winter-moisturisers collection
  if (window.location.href.includes('/collections/winter-moisturisers?page=2')) {
    window.location.href = '/collections/face-moisturizer-for-dry-skin'; // <-- your target page
  }
  if (window.location.href.includes('/collections/face-moisturizer?page=2')) {
    window.location.href = '/collections/face-moisturizer'; // <-- your target page
  }
      if (window.location.href.includes('/collections/winter-hair-shampoo?page=2')) {
    window.location.href = '/collections/hair-shampoo'; // <-- your target page
  } 
       if (window.location.href.includes('/collections/summer-hair-shampoo?page=2')) {
    window.location.href = '/collections/hair-shampoo'; // <-- your target page
  }
       if (window.location.href.includes('/collections/hair-shampoo?page=2')) {
    window.location.href = '/collections/hair-shampoo'; // <-- your target page
  } 
          if (window.location.href.includes('/collections/hair-shampoo?price=0-500')) {
    window.location.href = '/collections/hair-shampoo'; // <-- your target page
  }
       if (window.location.href.includes('/collections/hair-shampoo?price=7-14')) {
    window.location.href = '/collections/hair-shampoo'; // <-- your target page
  }
        if (window.location.href.includes('/collections/Action/products/banana-deeply-nourishing-shampoo-300-ml')) {
    window.location.href = '/products/banana-deeply-nourishing-shampoo-300-ml'; // <-- your target page
  }
      if (window.location.href.includes('/collections/Action/products/argan-oil-from-morocco-shampoo-300ml')) {
    window.location.href = '/products/argan-oil-from-morocco-shampoo-300ml'; // <-- your target page
  }
  const redirectsMap = {
    // Redirect these to /collections/all
    "/collections/winter-essentials": "/collections/all",
    "/collections/gels": "/collections/all",
    "/collections/summer-essentials": "/collections/all",
    "/collections/farmacy": "/collections/all",
    "/collections/farmacy?page=7": "/collections/all",
    "/collections/farmacy?page=2": "/collections/all",
    "/collections/farmacy?page=8": "/collections/all",
    "/collections/almond-oil": "/collections/all",
    "/collections/superstar-skin-am-pm-routine?p=1": "/collections/all",
    "/collections/all-products": "/collections/all",
    "/collections/all-products?page=5": "/collections/all",
    "/collections/pharmacy": "/collections/all",
    "/collections/action": "/collections/all",
    "/collections/plp": "/collections/all",
    "/collections/all?page=2": "/collections/all",
    "/collections/all?page=9": "/collections/all",
    "/collections/All/products/vitamin-e-skincare-kit": "/collections/all",
    "/collections/all-products?page=5": "/collections/all",
    "/collections/All/products/deep-pigmentation-kit": "/collections/all",
    "/collections/Combos/products/deep-pigmentation-kit": "/collections/all",
    "/collections/All/products/biotique-royal-saffron-50ml": "/collections/all",
    "/collections/Action/products/dandelionspotless-radiance-serum-30-ml": "/collections/all",
    "/collections/All/products/biotique-rejuvinating-vetiver-50ml": "/collections/all",
    "/collections/summer-essentials?page=5": "/collections/all",
    "/collections/summer-essentials?page=6": "/collections/all",
    "/collections/All/products/my-beauty-bundle-skincare-combo": "/collections/all",
    "/collections/Action/products/apple-cider-vinegar-anti-imperfection-daily-solution-30ml": "/collections/all",

    // Redirect hair color URLs to /collections/hair-color
    "/collections/summer-hair-color": "/collections/hair-color",
    "/collections/hair/hair-color": "/collections/hair-color",
    "/collections/winter-hair-color": "/collections/hair-color",
    "/collections/hair-color/color": "/collections/hair-color",

    // Sun care redirects → /collections/sunscreen
    "/collections/natural-sun-protection-lotion": "/collections/sunscreen",
    "/collections/natural-sun-protection-lotion?price=0-500": "/collections/sunscreen",
    "/collections/winter-sunscreen": "/collections/sunscreen-for-dry-skin",
    "/collections/All/products/pack-of-2-morning-nectar-sun-protect-moisturizer-30-spf-120ml": "/collections/sunscreen",
    "/collections/All/products/biotique-sandalwood-sunscreen-stick-spf-50": "/collections/sunscreen",
    "/collections/All/products/sandalwood-sunshield-spf-50-lotion-150ml": "/collections/sunscreen",
    "/collections/All/products/sun-shield-kit": "/collections/sunscreen",

     // Face Pack URLs → /collections/face-pack
    "/collections/summer-face-pack": "/collections/face-mask-for-oily-skin",
    "/collections/summer-face-pack?page=2": "/collections/face-mask-for-oily-skin",
    "/collections/winter-face-pack": "/collections/face-mask-for-dry-skin",
    "/collections/winter-face-pack?page=2": "/collections/face-mask-for-dry-skin",
     "/collections/face-masks": "/collections/face-mask",
    // Matching encoded URL strings with phcursor
    "/collections/summer-face-pack?page=2&phcursor": "/collections/face-mask-for-oily-skin",
    "/collections/winter-face-pack?page=2&phcursor": "/collections/face-mask-for-dry-skin",

    // Body Lotion → /collections/body-lotion
    "/collections/winter-body-lotion": "/collections/body-lotion-for-dry-skin",
    "/collections/treatment-lotions": "/collections/body-lotion",
    "/collections/lotions-creams": "/collections/body-lotion",
    "/collections/All/products/pack-of-2-coconut-brightening-cream": "/collections/body-lotion",
    "/collections/body-lotion/dryness": "/collections/body-lotion-for-dry-skin",
    "/collections/body-lotion/lightening-and-brightening": "/collections/body-lotion",

     //Soap → /collections/soap
    "/collections/winter-soap": "/collections/soap",
    "/collections/soaps/body-de-tox-de-stress": "/collections/soap",
    "/collections/Action/products/biotique-orange-peel-renewing-bathing-bar-150g-pack-of-3": "/collections/soap",
    "/collections/soap?p=2": "/collections/soap",
    "/collections/soaps/uneven-skin-tone": "/collections/soap",
    "/collections/soaps?utm_campaign": "/collections/soap",
    "/collections/soap?utm_campaign=post_promotion_Jan2020&utm_medium=Biotique&utm_source=Facebook":"/collections/soap",
    "/collections/tan-removal?price=0-7":"/collections/tan-removal",

    // Redirect various skincare-related paths to /collections/skin-care

  "/collections/skin-care?p=2": "/collections/skin-care",
  "/collections/skin-care?page=2&phcursor=eyJhbGciOiJIUzI1NiJ9.eyJzayI6InByb2R1Y3RfbGluZV9pdGVtc19jb3VudCIsInN2IjoxNDQ1LCJkIjoiZiIsInVpZCI6MzMxNTg0ODkzNzQ5NTgsImwiOjE2LCJvIjowLCJyIjoiQ0RQIiwidiI6MX0.tEavBYbknLwHXS0zzHjwbPwGeQ5EYiK1CcbizPz1eAw": "/collections/skin-care",
  "/collections/All/products/perfect-dry-skincare-kit": "/collections/skin-care",
  "/collections/Combos/products/perfect-dry-skincare-kit": "/collections/skin-care",
  "/collections/All/products/flawless-skincare-combo": "/collections/skin-care",
  "/collections/skin-care?utm_campaign=calendar_post_march&utm_medium=post&utm_source=facebook": "/collections/skin-care",
  "/collections/gels?item_concern=32": "/collections/skin-care",
  "/collections/gels?page=2": "/collections/skin-care",

    // Redirect various body wash-related paths to /collections/body-wash

  "/collections/summer-body-wash": "/collections/body-wash-for-oily-skin",
  "/collections/winter-body-wash": "/collections/body-wash-for-dry-skin",
  "/collections/summer-page/body-wash": "/collections/body-wash-for-oily-skin",
  "/collections/body-wash/uneven-skin-tone": "/collections/body-wash",
  "/collections/body-wash/dryness": "/collections/body-wash",
  "/collections/body-wash?utm_campaign=calendar_post_june&utm_medium=post&utm_source=facebook": "/collections/body-wash",
  "/collections/All/products/almond-oil-body-cleanser-75gteddy-soap": "/collections/body-wash",

    // Redirect various facial kit-related paths to /collections/facial-kits
  "/collections/summer-facial-kits": "/collections/facial-kits-for-oily-skin",
  "/collections/winter-facial-kits": "/collections/facial-kits-dry-skin",
  "/collections/skin-lightening/facial-kits": "/collections/facial-kits",
  "/collections/winter-facial-kit": "/collections/facial-kits-dry-skin",
  "/collections/facial-kits?p=2": "/collections/facial-kits",

  // Redirect various face scrub-related paths to /collections/face-scrub

  "/collections/summer-face-scrub": "/collections/face-scrub-for-oily-skin",
  "/collections/winter-face-scrub": "/collections/face-scrub-for-dry-skin",
  "/collections/skin-lightening/face-scrub": "/collections/face-scrub",
    
    // Redirect various hair-related paths to /collections/hair-care
  "/collections/Action/products/argan-oil-from-morocco-hair-mask-175gm?page=2": "/collections/hair-care",
  "/collections/Combos/products/anti-hair-fall-care-kit": "/collections/hair-care",
  "/collections/All/products/anti-hair-fall-care-kit": "/collections/hair-care",
  "/collections/Action/products/almond-cashew-hair-serum-colour-protect?page=2": "/collections/hair-care",
  "/collections/hair-care?p=2": "/collections/hair-care",
    
    // Redirect various body care-related paths to /collections/body-care
  "/collections/body-de-tox-de-stress": "/collections/body-care",
  "/collections/Combos/products/nourish-shine-bodycare-combo": "/collections/body-care",
  "/collections/All/products/nourish-shine-bodycare-combo": "/collections/body-care",
  "/collections/All/products/body-and-bath-kit": "/collections/body-care",
  "/collections/Combos/products/body-and-bath-kit": "/collections/body-care",
  "/collections/Combos/products/natural-bodycare-kit": "/collections/body-care",
  "/collections/All/products/natural-bodycare-kit": "/collections/body-care",

    // Redirect various anti-aging-related paths to /collections/anti-aging

  "/collections/anti-aging/serums": "/collections/anti-aging",
  "/collections/anti-aging/toners": "/collections/anti-aging",
  "/collections/anti-aging/face-pack": "/collections/anti-aging",
  "/collections/anti-aging/prevention-protection": "/collections/anti-aging",
  "/collections/All/products/anti-ageing-kit": "/collections/anti-aging",

    "/collections/body-scrub?item_concern=31": "/collections/body-scrub",
    
    // Redirect uneven skin tone and pigmentation-related paths to /collections/pigmentation

  "/collections/uneven-skin-tone": "/collections/pigmentation",
  "/collections/uneven-skin-tone?p=2": "/collections/pigmentation",
  "/collections/pigmentation?price=7-14": "/collections/pigmentation",
  "/collections/pigmentation?price=0-7": "/collections/pigmentation",
    
    // Redirect various lip care-related paths to /collections/lip-care
  "/collections/winter-lip-care": "/collections/lip-care",
  "/collections/skin-lightening/lip-care": "/collections/lip-care",
  "/collections/lip-care/dryness?order=name": "/collections/lip-care",
  "/collections/lip-care/skin-lightening?order=name": "/collections/lip-care",
  "/collections/lip-care?cat=254&dir=asc&item_type=358_357_383&order=name&price=2,500": "/collections/lip-care",

     "/collections/dark-circles-puffiness/prevention-protection": "/collections/dark-circles-puffiness",
  "/collections/dark-circles-puffiness/lightening-and-brightening": "/collections/dark-circles-puffiness",

    // Redirect various specific category/product paths to their intended target collections
  "/collections/hair/hair-treatment": "/collections/hair-treatment",
  "/collections/eye-care?price=0-7": "/collections/eye-care",
  "/collections/Action/products/perfect-grooming-kit": "/collections/men",
  "/collections/dryness?p=2": "/collections/dryness",
  "/collections/acne-oil-control/dryness": "/collections/acne-oil-control",
  "/collections/acne-oil-control/uneven-skin-tone": "/collections/acne-oil-control",
  "/collections/hair-shampoo/dry-hair": "/collections/dry-hair",
  "/collections/monsoon-must-buy": "/collections/bestseller",
  "/collections/Bestseller/products/pack-of-2-coconut-brightening-cream": "/collections/bestseller",
  "/collections/monsoon-must-buy?page=2&phcursor=eyJhbGciOiJIUzI1NiJ9.eyJzayI6InByb2R1Y3RfbGluZV9pdGVtc19jb3VudCIsInN2Ijo2NTcsImQiOiJmIiwidWlkIjozNDM5MzkzNzA4NDY1NCwibCI6MTYsIm8iOjAsInIiOiJDRFAiLCJ2IjoxfQ.enRNA-2lrjVcJOUy182lcXQt7FSNDi9d8h1dbiy9jGo": "/collections/bestseller",
  "/collections/natural-makeup-homes": "/collections/natural-makeup",
  "/collections/natural-makeup?item_collection=365": "/collections/natural-makeup",
  "/collections/natural-makeup?item_collection=500&item_type=359_353": "/collections/natural-makeup",
  "/collections/natural-makeup?item_type=359_353&p=3": "/collections/natural-makeup",
  "/collections/lipsticks?price=0-500": "/collections/lipsticks",  
  "/collections/Combos/products/hair-regrowth-kit": "/collections/hair-regrowth",
  "/collections/All/products/hair-regrowth-kit": "/collections/hair-regrowth",
  "/collections/after-bath": "/collections/baby-care",
  "/collections/All/products/almond-oil-baby-soap-75gprincess-soap": "/collections/baby-care",
  "/collections/Action/products/bitoique-basil-sandalwood-baby-powder-150-gm-mickey-powder": "/collections/baby-care",
    
    // Redirect to /collections/lip-balm
  "/collections/Action/products/magikisses-lip-balm": "/collections/lip-balm",
  "/collections/Action/products/morning-nectar-lip-balm-advanced-ayurveda-for-visibly-flawless-lips": "/collections/lip-balm",

  // Redirect to /collections/foundation
  "/collections/foundation?item_collection=367&item_type=350": "/collections/foundation",
  "/collections/All/products/stardew-insta-glow-foundation": "/collections/foundation",

  // Redirect to /collections/gifting
  "/collections/valentine-gift-set": "/collections/gifting",

  // Redirect to /collections/morning-nectar
  "/collections/morning-nectar?price=0-7": "/collections/morning-nectar",
  "/collections/winter-toners": "/collections/face-toner-for-dry-skin",
  "/collections/winter-toners,": "/collections/face-toner-for-dry-skin",

  // Redirect to /collections/combos
  "/collections/skincare-combos": "/collections/combos",
  "/collections/hair-care-combos": "/collections/combos",
  "/collections/mens-combos": "/collections/combos",
  "/collections/fragrance-combos": "/collections/combos",
  "/collections/body-combos": "/collections/combos",
  "/collections/pack-of-2-sets": "/collections/combos",
  "/collections/All/products/anti-tan-combo": "/collections/combos",
  "/collections/Combos/products/summer-care-kit": "/collections/combos",
  "/collections/All/products/summer-care-kit": "/collections/combos",
  "/collections/combos?page=3": "/collections/combos",
  "/collections/All/products/vitamin-c-radiance-skincare-combo": "/collections/combos",
  "/collections/Combos/products/face-and-bodycare-kit": "/collections/combos",
  "/collections/All/products/face-and-bodycare-kit": "/collections/combos",
  "/collections/All/products/papaya-tan-removal-regime": "/collections/combos",
  "/collections/Combos/products/face-wash-and-body-wash-combo": "/collections/combos",
  "/collections/All/products/cleanse-and-nourish-combo": "/collections/combos",
  "/collections/Combos/products/summer-skincare-routine-combo": "/collections/combos",
  "/collections/Combos/products/cleanse-and-nourish-combo": "/collections/combos",
  "/collections/All/products/summer-skincare-routine-combo": "/collections/combos",
  "/collections/All/products/face-wash-and-body-wash-combo": "/collections/combos",
  "/collections/Combos/products/refreshing-skincare-combo": "/collections/combos",
  "/collections/combos?price=0-7": "/collections/combos",
  "/collections/Combos/products/papaya-tan-removal-regime": "/collections/combos",
  "/collections/All/products/refreshing-skincare-combo": "/collections/combos",
  "/collections/Combos/products/summer-refreshing-kit": "/collections/combos",
  "/collections/All/products/summer-refreshing-kit": "/collections/combos",
  "/collections/All/products/basil-parsley-soap-combo": "/collections/combos",
  "/collections/All/products/daily-skin-care-essential-gift-kit": "/collections/combos",
  "/collections/Combos/products/my-beauty-bundle-skincare-combo": "/collections/combos",
  "/collections/All/products/summer-care-kit-combo": "/collections/combos",
  "/collections/Combos/products/summer-care-kit-combo": "/collections/combos",
  "/collections/Combos/products/natural-deep-hydration-combo": "/collections/combos",
  "/collections/Combos/products/flawless-skincare-combo": "/collections/combos",
  "/collections/Combos/products/sun-shield-kit": "/collections/combos",

 
  };

  const currentPath = window.location.pathname + window.location.search;

  // Find the matching redirect (startsWith handles paginated or variant URLs)
  for (const [fromPath, toPath] of Object.entries(redirectsMap)) {
    if (currentPath.startsWith(fromPath)) {
      window.location.replace(toPath);
      break;
    }
  }


  (function () {
    const redirects = {
      // Redirect to /collections/compact
      "/collections/compact?price=0-7": "/collections/compact",
      "/collections/All/products/startouch-falwless-matte-compact": "/collections/compact",

      // Redirect to /collections/highlighters
      "/collections/pore-perfection": "/collections/highlighters",
      "/collections/illuminator": "/collections/highlighters",

      // Redirect to /collections/makeup-remover
      "/collections/All/products/berberry-milk-deep-cleanse-hydrating-make-up-remover-120ml": "/collections/makeup-remover",
      "/collections/makeup-remover/dryness": "/collections/makeup-remover",

      // Redirect to /collections/blush
      "/collections/blush?item_collection=493": "/collections/blush",
      "/collections/blush?price=0-7": "/collections/blush",
      "/collections/All/products/starstruck-matte-blush": "/collections/blush",

      // Redirect to /collections/lip-gloss
      "/collections/All/products/starshimmer-glam-lipgloss": "/collections/lip-gloss",

      // Redirect to /collections/blemishes
      "/collections/blemishes/acne-treatment": "/collections/blemishes",

      // Redirect to /collections/advanced-ayurveda
      "/collections/advanced-ayurveda?page=6&phcursor=...": "/collections/advanced-ayurveda",
      "/collections/All/products/ayurveda-shampoo-conditioner-kit": "/collections/advanced-ayurveda",

      // Redirect to /collections/travel-kit
      "/collections/summer-page/travel-kit": "/collections/travel-kit",
      "/collections/All/products/biotique-travel-kit-4-products-35ml-x-4": "/collections/travel-kit",

      // Redirect to /collections/body-powder
      "/collections/refreshing": "/collections/body-powder",
      "/collections/body-powder?item_concern=42": "/collections/body-powder",
      "/collections/body-powder/refreshing": "/collections/body-powder",

      // Redirect to /collections/advanced-organics
      "/collections/advanced-organics/haircare": "/collections/advanced-organics",
      "/collections/advanced-organics/bodycare": "/collections/advanced-organics",
      "/collections/advanced-organics?p=2": "/collections/advanced-organics",
      "/collections/advanced-organics?p=3": "/collections/advanced-organics",

      // Redirect to /collections/vitamin-c
      "/collections/vitamin-c?price=0-7": "/collections/vitamin-c",
      "/collections/Combos/products/vitamin-c-radiance-skincare-combo": "/collections/vitamin-c",

      // Redirect to /collections/eye-brow-filler
      "/collections/eye-brow-filler?item_collection=29&item_type=356": "/collections/eye-brow-filler",

      // Redirect to /collections/kajal-pencil
      "/collections/Action/products/biotique-magikhol-ebony-black?page=2": "/collections/kajal-pencil",
      "/collections/kajal-pencil?price=1,500": "/collections/kajal-pencil",
      "/collections/Action/products/biotique-magikajal-intense-black-010-3g": "/collections/kajal-pencil",
      "/collections/kajal-pencil?item_type=352": "/collections/kajal-pencil",

      // Redirect to /collections/bxl-cellular
      "/collections/bxl-cellular?item_concern=31&price=500-1000": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-cleansing-solution-for-all-skin-types-200ml": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-sleep-cream-for-normal-to-dry-skin-50gm": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-hydrating-eye-gel-for-all-skin-types-15gm": "/collections/bxl-cellular",
      "/collections/Action/products/bxl-cellular-firming-pack-for-all-skin-types-50g": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-protection-cream-spf-30-uva-uvb-sunscreen-for-all-skin-types-50gm": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-hydrating-scrub-for-all-skin-types-50gm": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-protection-cream-spf-50-uva-uvb-sunscreen-for-all-skin-types-50gm": "/collections/bxl-cellular",
      "/collections/Action/products/bxl-cellular-lip-repair-balm-for-all-skin-types-15gm": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-resurfacing-scrub-for-normal-to-dry-skin-50gm": "/collections/bxl-cellular",
      "/collections/All/products/bxl-cellular-protection-cream-spf-40-uva-uvb-sunscreen-for-all-skin-types-50gm": "/collections/bxl-cellular",

      // Redirect to /collections/eye-shadow
      "/collections/All/products/stardust-eye-shadow": "/collections/eye-shadow",

      // Redirect to /collections/treatment-oil
      "/collections/winter-treatment-oil": "/collections/treatment-oil",

      // Redirect to /collections/mascara
      "/collections/All/products/diva-dreams-two-in-one-mascara-onyx": "/collections/mascara",
      "/collections/mascara?price=7-14": "/collections/mascara",
      "/collections/mascara?order=name": "/collections/mascara",
      "/collections/All/products/starryeyes-mascaraebony-black": "/collections/mascara",

      // Redirect to /collections/diva
      "/collections/All/products/diva-satin-smooth-3-in-1-compact-makeup?page=2": "/collections/diva",

      // Redirect to /collections/magic
      "/collections/All/products/magicare-all-day-foundation": "/collections/magic",

      // Redirect to /collections/new-launches
      "/collections/new-launches?price=0-7": "/collections/new-launches",
      "/collections/new-launches?price=7-14": "/collections/new-launches",

      // Redirect to /collections/pore-tightening
      "/collections/pore-tightening?item_concern=39": "/collections/pore-tightening",
      "/collections/pore-tightening?item_concern=31": "/collections/pore-tightening",

      // Redirect to /collections/clearance-sale
      "/collections/buy-at-499": "/collections/clearance-sale",
      "/collections/liquidation-sheet-offers": "/collections/clearance-sale",
      "/collections/offer-products?page=16&phcursor=...": "/collections/clearance-sale",

      // Redirect to /collections/star/foundation
      "/collections/All/products/starburst-matte-moussse-foundation": "/collections/star/foundation"
    };

    const currentPath = window.location.pathname + window.location.search;
    const target = redirects[currentPath];

    if (target) {
      window.location.href = target;
    }
  })();

